module.exports = __webpack_public_path__ + "h5/img/open-ball1.710433a4.png";